var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 80,
    viewBox: "0 0 93 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_38_2822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9555 44.9922L40.3445 56.2181L53.5485 56.1887L46.9555 44.9922Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7158 22.4877L13.852 56.1964H27.0755L40.3268 33.7136L33.7158 22.4877Z",
    fill: "#0089CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.544 33.6598L66.8817 56.2159H80.0416L60.1223 22.4877L53.544 33.6598Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5485 11.1797L46.9555 -0.0168457L40.3445 11.2107L46.9375 22.4072L53.5485 11.1797Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5748 65.2347C33.7918 65.2347 35.5873 66.8867 35.5873 69.667C35.5873 71.8424 33.9875 73.4177 31.6638 73.7373L36.0145 79.7417H32.7498L28.5654 74.0602H22.7111V79.7417H20.1492V65.2347H29.5764H29.5748ZM22.7095 67.7933V71.5424H29.9401C31.4355 71.5424 33.0238 71.4201 33.0238 69.667C33.0238 67.914 30.987 67.7917 29.8895 67.7917H22.7095V67.7933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8172 79.9796L61.1967 70.5165L60.5835 70.0126V79.7383H58.0217V64.99H58.0478L69.6683 74.4531L70.2814 74.957V65.2313H72.8433V79.9796H72.8172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7427 79.7403H17.7726L8.91285 64.6838H8.85904L-0.000671387 79.7403H3.03084L4.54904 77.1197H13.2033L14.7443 79.7403H14.7427ZM8.88676 69.5385C10.1294 71.541 10.6642 72.4868 11.9134 74.6166H5.83242C7.14026 72.4004 7.63436 71.541 8.88676 69.5385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7899 79.743H92.8198L83.9601 64.6865H83.9063L75.0466 79.743H78.0781L79.5963 77.1224H88.2505L89.7916 79.743H89.7899ZM83.934 69.5412C85.1766 71.5437 85.7115 72.4895 86.9606 74.6193H80.8797C82.1875 72.4031 82.6816 71.5437 83.934 69.5412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7918 77.183V73.6672H52.7392V71.164H42.7918V67.7917H53.8758V65.2347H40.2283V79.74H54.2769V77.183H42.7918Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_38_2822"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.8109,
    height: 80,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewLogo);
export default __webpack_public_path__ + "static/media/newLogo.cbf9f96bac8c3d9271154011cd808b70.svg";
export { ForwardRef as ReactComponent };